export enum SectionObjectEnum {
  Section = 'Section',
  Channel = 'Channel',
  Content = 'Content',
  User = 'User',
}
